import React from 'react';
import { Tooltip } from '@mui/material';

const CustomTooltip = ({ title, children, padding, borderRadius, topBorderRadius, width, height, popperProps, placement = 'bottom-end', ...tooltipProps }) => {
    const getStartBorderRadius = (radius) => {
        const corners = radius.split(/\s+/);

        return corners.length === 4
            ? `${corners[1]} ${corners[0]} ${corners[3]} ${corners[2]}`
            : radius;
    };

    const resolvedBorderRadius = borderRadius || '8px';
    const tooltipPopperProps = {
        ...popperProps,
        sx: {
            ...popperProps?.sx,
            '&[data-popper-placement*="bottom-start"] .MuiTooltip-tooltip': {
                borderRadius: getStartBorderRadius(resolvedBorderRadius),
            },
            '&[data-popper-placement*="top-end"] .MuiTooltip-tooltip': {
                borderRadius: topBorderRadius || resolvedBorderRadius,
            },
            '&[data-popper-placement*="bottom-end"] .MuiTooltip-arrow': {
                right: 0,
                left: 'auto !important',
                '&::before': {
                    borderLeft: '15px solid transparent',
                    borderRight: 'none',
                    right: 0,
                    left: 'auto !important',
                },
            },
            '&[data-popper-placement*="bottom-start"] .MuiTooltip-arrow': {
                right: 'auto',
                left: '0 !important',
                '&::before': {
                    borderLeft: 'none',
                    borderRight: '15px solid transparent',
                    right: 'auto',
                    left: '0 !important',
                },
            },
            '&[data-popper-placement*="top-end"] .MuiTooltip-arrow': {
                top: 'auto',
                bottom: '0 !important',
                right: 0,
                left: 'auto !important',
                '&::before': {
                    borderLeft: '15px solid transparent',
                    borderRight: 'none',
                    borderTop: '15px solid #121a22',
                    borderBottom: 'none',
                    right: 0,
                    left: 'auto !important',
                    top: 'auto',
                    bottom: 0,
                },
            },
        },
    };

    return (
        <Tooltip 
            {...tooltipProps}
            title={title}
            arrow
            placement={placement}
            PopperProps={tooltipPopperProps}
            componentsProps={{
                tooltip: {
                    sx: {
                        fontFamily: 'Noto Sans',
                        backgroundColor: '#121a22',
                        fontSize: 14,
                        padding: padding || '5px 16px',
                        borderRadius: resolvedBorderRadius,
                        width: width || 'auto',
                        height: height || 'auto',
                        fontWeight:400,
                        fontStyle:'normal',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: "8px",
                        boxSizing: 'border-box',
                        maxWidth: 'none'
                    }
                },
                arrow: { sx: {
                    pointerEvents: 'none',
                    transform: 'none !important',
                    '&::before': {
                        border: 'none',
                        backgroundColor: 'transparent',
                        width: 0,
                        height: 0,
                        borderBottom: '15px solid #121a22',
                        borderTop: 'none',
                        position: 'absolute',
                        transform: 'none !important'
                    }
                } }
            }}
        >
            {children}
        </Tooltip>
    );
};

export default CustomTooltip;
